// extracted by mini-css-extract-plugin
module.exports = {"list":"IconList_list__gjHpz"};